var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"v-application"},[_c('navigation-menu')],1),_c('div',{staticClass:"router-view-container"},[_c('header-nav-bar'),_c('transition',{attrs:{"name":"slide-fade","mode":"out-in"}},[_c('router-view',{on:{"setAppClasses":(classesStr) => _vm.$emit('setAppClasses', classesStr)}})],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }